import { FormTypes } from '../../../../components/FormGenerator';
import VenueRegistrationFormModal from '../../shared/VenueRegistrationFormModal';

class CompetitiveProgramme extends VenueRegistrationFormModal {
	constructor() {
		super({
			modalSelector: '#competition-programme-form-modal',
			triggerSelectors: ['.js-program-landing-add-competition', '.js-program-landing-edit-competition'],
			stepsEndpointAttr: 'competition-steps-endpoint',
			submitEndpointAttr: 'competition-submit-endpoint',
			logPrefix: 'CompetitiveProgramme'
		});
	}

	getFormGeneratorOptions() {
		return {
			totalSteps: 1,
			formType: FormTypes.SectionForm,
			exitButtonLabel: 'Save and Exit',
			hasSeparator: true,
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Save and continue',
				alwaysVisible: true
			}
		};
	}
}

VenueRegistrationFormModal.boot(CompetitiveProgramme);

export default CompetitiveProgramme;
